import React, { useState } from 'react'
import { StyledLabel } from '../../assets/styledComponents/Global'
import { useTheme } from 'styled-components'
import DescriptionModal from './DescriptionModal';
import { useWindowSize } from '../../utils/helper';

const QuestionInfo = ({ currentQuestion, questionsList }) => {
    const theme = useTheme();
    const [showDescription, setShowDescription] = useState(false);
    const actualIndex = questionsList.findIndex(
        (q) => q.id === currentQuestion?.id
    );
    const isSmallScreen = useWindowSize();

    const ReadMoreText = (text, limit) => {

        const isLong = text.length > limit;
        const displayText = text.slice(0, limit) + (isLong ? "..." : "");
        return (
            <div>
                <span>{displayText}</span>
                {isLong && (
                    <button
                        onClick={() => setShowDescription(true)}
                        className="btn btn-link p-0 ms-1"
                        style={{ fontSize: "14px" }}
                    >
                        {"See More"}
                    </button>
                )}
            </div>
        );
    };


    return (
        <div className="d-flex flex-column align-item-center justify-content-start mb-4">
            {!isSmallScreen && <div className='d-flex align-items-center gap-2 mb-2'>
                <div className='p-2 bg-white rounded-3 '>
                    <StyledLabel
                        size="16px"
                        fontWeight="500"
                        className='w-max'
                        color={theme?.subText}
                    >
                        Question {actualIndex + 1}:{' '}
                    </StyledLabel>
                </div>
            </div>}

            {isSmallScreen && <div className='d-flex align-items-center gap-2'>
                <div className='p-1 bg-body rounded-3  max-w-fit'>
                    <StyledLabel
                        size="12px"
                        fontWeight="500"
                        className='w-max font-fredoka'

                        color={theme?.subText}
                    >
                        Duration
                    </StyledLabel>
                    <StyledLabel
                        size="12px"
                        fontWeight="400"
                        className='w-max font-fredoka fw-normal'
                        color={theme?.subText}
                    >
                        : {currentQuestion?.duration / 60} {currentQuestion?.duration > 60 ? 'Mins' : 'Min'}
                    </StyledLabel>
                </div>
                {currentQuestion?.retakes > 0 ?
                    <div className='p-1 bg-body rounded-3  max-w-fit'>
                        <StyledLabel
                            size="12px"
                            fontWeight="500"
                            className='w-max font-fredoka'
                            color={theme?.subText}
                        >
                            Retakes
                        </StyledLabel>
                        <StyledLabel
                            size="12px"
                            fontWeight="400"
                            className='w-max font-fredoka fw-normal'
                            color={theme?.subText}
                        >
                            : {currentQuestion?.retakes}
                        </StyledLabel>
                    </div> : <div className='p-1 bg-body rounded-3  max-w-fit'>
                        <StyledLabel
                            size="12px"
                            fontWeight="500"
                            className='w-max font-fredoka'
                            color={theme?.subText}
                        >
                            No Retakes Allowed
                        </StyledLabel>
                    </div>}
                {currentQuestion?.thinkTime > 0 && <div className='p-1 bg-body rounded-3 max-w-fit'>
                    <StyledLabel
                        size="12px"
                        fontWeight="500"
                        className='w-max font-fredoka'
                        color={theme?.subText}
                    >
                        Preparation Time               </StyledLabel>
                    <StyledLabel
                        size="12px"
                        fontWeight="400"
                        className='w-max font-fredoka fw-normal'
                        color={theme?.subText}
                    >
                        : {currentQuestion?.thinkTime / 60} {currentQuestion?.thinkTime > 60 ? 'Mins' : 'Min'}
                    </StyledLabel>
                </div>}
            </div>}
            <StyledLabel
                size={isSmallScreen ? '20px' : "22px"}
                fontWeight={isSmallScreen ? "600" : "500"}
                color={theme?.darktext}
                className="mb-2 ms-1"
            >
                {currentQuestion?.text}
            </StyledLabel>

            <StyledLabel
                size={isSmallScreen ? "14px" : "15px"}
                fontWeight={isSmallScreen ? "400" : "500"}
                color={theme?.subText}
                className="mb-3 ms-1"
            >
                {isSmallScreen ? currentQuestion?.description : ReadMoreText(currentQuestion?.description, 83)}
            </StyledLabel>


            {!isSmallScreen && <div className='d-flex align-items-center gap-2'>
                <div className='p-2 bg-white rounded-3  max-w-fit'>
                    <StyledLabel
                        size="12px"
                        fontWeight="500"
                        className='w-max font-fredoka'

                        color={theme?.subText}
                    >
                        Maximum  Duration
                    </StyledLabel>
                    <StyledLabel
                        size="12px"
                        fontWeight="400"
                        className='w-max font-fredoka fw-normal'
                        color={theme?.subText}
                    >
                        : {currentQuestion?.duration / 60} {currentQuestion?.duration > 60 ? 'Minutes' : 'Minute'}
                    </StyledLabel>
                </div>
                {currentQuestion?.retakes > 0 ?
                    <div className='p-2 bg-white rounded-3  max-w-fit'>
                        <StyledLabel
                            size="12px"
                            fontWeight="500"
                            className='w-max font-fredoka'
                            color={theme?.subText}
                        >
                            Retakes Allowed
                        </StyledLabel>
                        <StyledLabel
                            size="12px"
                            fontWeight="400"
                            className='w-max font-fredoka fw-normal'
                            color={theme?.subText}
                        >
                            : {currentQuestion?.retakes}
                        </StyledLabel>
                    </div> : <div className='p-2 bg-white rounded-3  max-w-fit'>
                        <StyledLabel
                            size="12px"
                            fontWeight="500"
                            className='w-max font-fredoka'
                            color={theme?.subText}
                        >
                            No Retakes Allowed
                        </StyledLabel>
                    </div>}
                {currentQuestion?.thinkTime > 0 && <div className='p-2 bg-white rounded-3 max-w-fit'>
                    <StyledLabel
                        size="12px"
                        fontWeight="500"
                        className='w-max font-fredoka'
                        color={theme?.subText}
                    >
                        Preparation Time               </StyledLabel>
                    <StyledLabel
                        size="12px"
                        fontWeight="400"
                        className='w-max font-fredoka fw-normal'
                        color={theme?.subText}
                    >
                        : {currentQuestion?.thinkTime / 60} {currentQuestion?.thinkTime > 60 ? 'Minutes' : 'Minute'}
                    </StyledLabel>
                </div>}
            </div>}

            {showDescription &&
                <DescriptionModal
                    show={showDescription}
                    onHide={() => setShowDescription(false)}
                    data={currentQuestion}
                    index={actualIndex}
                />
            }
        </div>
    )
}

export default QuestionInfo